<template>
  <div>
    <fieldset class="border p-3">
      <legend>
        <small style="font-size: 15px; font-weight: bold">Petty cash</small>
      </legend>
      <div>
        <form @submit.prevent="newPettycash()">
          <div class="form-group">
            <label>Account</label>
            <select name="account_id" class="form-control account_id input-rounded f-s-14">
              <option value>Select account</option>
              <option
                v-for="accounttype in systemPettyaccounts"
                :value="accounttype.id"
                :key="accounttype.id"
              >{{ accounttype.pettyaccounts_name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Petty cash amount</label>
            <input
              type="number"
              class="form-control disbursed_amount input-rounded f-s-14"
              placeholder="disbursed amount"
              required
            />
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingPettycash btn-rounded">
            <i class="fa fa-plus"></i> create Pettycash
          </button>
          <button
            type="button"
            class="btn btn-primary btn-flat creatingPettycashLoader btn-rounded"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
   created() {
    this.loadPettyaccounts();
  },
  computed: {
    ...mapGetters(["systemPettyaccounts"])
  },
  methods: {
    ...mapActions(["newPettycash", "loadPettyaccounts"])
  }
};
</script>
<style scoped>
.creatingPettycashLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/pettycashes/pettycash.vue